import { createPositionalNodeId } from "app/pages/sales-intelligence/utils/taxonomy-tree/nodeId";
import type { TaxonomyIndex } from "app/pages/sales-intelligence/utils/taxonomy-tree/types";

declare const intentNodeIdBrand: unique symbol;

/**
 * Identifier of a node in the intent taxonomy. Branded so an id from another taxonomy cannot be passed
 * where this one is expected: every taxonomy built on the shared tree has structurally identical string
 * ids, so nothing else would catch a swapped index — the payload would just be wrong.
 */
export type IntentNodeId = string & { readonly [intentNodeIdBrand]: true };

export type IntentTaxonomyIndex = TaxonomyIndex<IntentNodeId>;

export const createIntentNodeId = (pathIndices: readonly number[]): IntentNodeId =>
    createPositionalNodeId<IntentNodeId>(pathIndices);
